import "./style.scss";
import { useDispatch } from "react-redux";
import { closeLoading, showLoading } from "../../redux/actions/appAction";
import { adminLoginApi } from "../../utils/api";
import { useState } from "react";
import { showAlert } from "../../redux/actions/alertAction";
import {
  setCookie,
  setLocalStorage,
} from "../../utils/general";

const tokenName = `${process.env.REACT_APP_ENVIRONMENT}qdweddingadmin`;

function Login() {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const onLogin = async (e) => {
    e.preventDefault();

    dispatch(showLoading());

    const adminLoginApiRes = await adminLoginApi(formData);

    dispatch(closeLoading());

    if (!adminLoginApiRes.data) {
      dispatch(showAlert("error", "Incorrect username and password"));
      return;
    }

    setCookie(tokenName, adminLoginApiRes.data);
    setLocalStorage(tokenName, adminLoginApiRes.data);

    window.location.replace("/");
  };

  const handleFieldChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4">
                  <div className="logo d-flex align-items-center w-auto">
                    <img
                      className="login__logo"
                      src="assets/img/KW-logo-icon.svg"
                      alt=""
                    />
                  </div>
                </div>
                {/* End Logo */}
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Login to Your Account
                      </h5>
                    </div>
                    <form className="row g-3 needs-validation" noValidate="">
                      <div className="col-12">
                        <label className="form-label">Username</label>
                        <div className="input-group has-validation">
                          <input
                            name="username"
                            type="email"
                            className="form-control"
                            value={formData["username"]}
                            onChange={handleFieldChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <label className="form-label">Password</label>
                        <input
                          name="password"
                          type="password"
                          className="form-control"
                          value={formData["password"]}
                          onChange={handleFieldChange}
                        />
                      </div>
                      <div className="col-12 mb-2 mt-4">
                        <button
                          className="submit__btn btn w-100"
                          onClick={onLogin}
                        >
                          Login
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Login;
